<script setup lang="ts">
import { ref, watch } from 'vue';
import { answerConfirm, confirmState } from '../services/notify';
import ModalDialog from './ModalDialog.vue';

const text = ref('');
watch(confirmState, (c) => (text.value = c?.prompt?.value ?? ''));

function cancel() {
  answerConfirm(confirmState.value?.prompt ? null : false);
}
function ok() {
  answerConfirm(confirmState.value?.prompt ? text.value : true);
}
</script>

<template>
  <ModalDialog v-if="confirmState" :title="confirmState.title ?? ''" size="sm" :scrollable="false" @close="cancel">
    <form id="creator-confirm" @submit.prevent="ok">
      <p class="mb-0" :class="{ 'mb-3': confirmState.prompt }" style="white-space: pre-line">{{ confirmState.message }}</p>
      <template v-if="confirmState.prompt">
        <label class="form-label" for="creator-confirm-input">{{ confirmState.prompt.label }}</label>
        <input id="creator-confirm-input" v-model="text" class="form-control" autofocus autocomplete="off" />
      </template>
    </form>
    <template #footer>
      <button type="button" class="btn btn-outline-secondary" @click="cancel">{{ confirmState.cancelLabel ?? $t('app.cancel') }}</button>
      <button type="submit" form="creator-confirm" class="btn" :class="confirmState.danger ? 'btn-danger' : 'btn-primary'" :autofocus="!confirmState.prompt">
        {{ confirmState.okLabel ?? $t('app.ok') }}
      </button>
    </template>
  </ModalDialog>
</template>
